import { Link } from "react-router-dom";
import {
  LOGO_NEGATIVE_URL,
  NAV_LINKS,
  navigateToHomeSection,
} from "@/lib/shared";

const linkSlug = (l) => (l.to ? l.to.replace(/^\//, "") : l.hash);

const Footer = () => (
  <footer className="cn-footer" data-testid="footer">
    <div className="cn-container cn-footer-inner">
      <div className="cn-footer-col cn-footer-left">
        <img
          src={LOGO_NEGATIVE_URL}
          alt="Caruna"
          loading="lazy"
          className="cn-footer-iso"
        />
        <span className="cn-footer-copy">© 2026 CARUNA</span>
      </div>
      <nav className="cn-footer-col cn-footer-center" aria-label="Pie">
        {NAV_LINKS.map((l) => {
          const testId = `footer-link-${linkSlug(l)}`;
          if (l.to) {
            return (
              <Link key={l.to} to={l.to} data-testid={testId}>
                {l.label}
              </Link>
            );
          }
          return (
            <a
              key={l.hash}
              href={`/#${l.hash}`}
              onClick={(e) => navigateToHomeSection(e, l.hash)}
              data-testid={testId}
            >
              {l.label}
            </a>
          );
        })}
      </nav>
      <div className="cn-footer-col cn-footer-right">
        <a
          href="https://caruna.com.mx/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-privacy"
        >
          Política de privacidad
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
